/* eslint-disable */

export * from './HttpActions';
export * from './AuthActions';
export * from './CustomerActions';
export * from './AssetsProducingActions';
export * from './AssetsConsumingActions';
export * from './DashboardActions';
export * from './CertificatesActions';
export * from './ReportsActions';
export * from './TransportCertificatesActions';
export * from './OrganizationActions';
export * from './CountryActions';
export * from './MatchingTypeActions';
export * from './MaintenanceActions';
export * from './LogsActions';
export * from './UtilsActions';
export * from './UsersActions';
export * from './ErrorActions';
export * from './Maintenance/UploadAssetMeteringActions'
export * from './Maintenance/DatabaseServiceActions'
export * from './Maintenance/MeteringServiceActions'

export const closeError = () => (dispatch) => {
  dispatch({ type: 'CLOSE_ERROR' });
};
export const closeSuccess = () => (dispatch) => {
  dispatch({ type: 'CLOSE_SUCCESS' });
};
export const closeInfo = () => (dispatch) => {
  dispatch({ type: 'CLOSE_INFO' });
};

export const openError = () => (dispatch) => {
  dispatch({ type: 'OPEN_ERROR', payload: "Error" });
};
export const openSuccess = () => (dispatch) => {
  dispatch({ type: 'OPEN_SUCCESS', payload: "Success" });
};
export const openInfo = () => (dispatch) => {
  dispatch({ type: 'OPEN_INFO', payload: "Info" });
};

export const testAction = () => {
  return {
    type: 'TEST_TOGGLE'
  }
}

export const handleErrors = (response) => {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}





// WEBPACK FOOTER //
// ./src/actions/index.js